/**
 * Labstep
 *
 * @module components/File/UploadToast
 * @desc Display file upload progress
 */

import { FileProgressContainer } from 'labstep-web/containers/File/Progress';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import { Progress } from 'semantic-ui-react';
import type { FileUploadToastProps } from './types';

export const FileUploadToast: React.FC<FileUploadToastProps> = ({
  files,
}) => (
  <Modal
    viewComponent={null}
    id="file-upload-modal"
    header="Uploading..."
    closeIcon={false}
    open={files.length > 0}
    content={() => (
      <div>
        {files.map((file) => (
          <div key={file.id}>
            <div>{(file as any).body.name}</div>
            <Progress
              color="blue"
              percent={(file as any).progress}
              progress
            />
          </div>
        ))}
      </div>
    )}
  />
);

export const FileUploadToastContainer: React.FC = () => (
  <FileProgressContainer>
    {({ files }) => <FileUploadToast files={files} />}
  </FileProgressContainer>
);
